.unsaved-warning{display:flex;align-items:center;gap:8px;margin-bottom:14px;padding:10px 12px;border-radius:8px;background:var(--danger-soft, #fff6e5);color:#8a5a12;font-size:13px;font-weight:600}.unsaved-warning i{font-size:12px}
/*# sourceMappingURL=end-demo.component-QEXZ2GHT.css.map */
